import { useId } from 'react';
import type { ProductLengthPick } from '~/components/common/productLengthChoice';

export function usePickedProductLength<T>(
  pick: ProductLengthPick,
  items: T[],
  lengthIdOf: (item: T) => string
) {
  const replaceNoticeId = useId();
  const pickedLengthId =
    pick.kind === 'length' && pick.platformProductsLength
      ? pick.platformProductsLength.id
      : undefined;
  const existingItem = pickedLengthId
    ? items.find((item) => lengthIdOf(item) === pickedLengthId)
    : undefined;
  const lineLengthIds = new Set(
    pick.kind === 'lengths'
      ? pick.lines.map((line) => line.platformProductsLength.id)
      : []
  );
  const existingLineItems = items.filter((item) =>
    lineLengthIds.has(lengthIdOf(item))
  );

  return { pickedLengthId, existingItem, existingLineItems, replaceNoticeId };
}
